import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import { ProductKey, TierProduct } from 'generated/types'

import { DYNAMIC_COPY } from './copy'
import {
  ProductHeaderCopy,
  ProductHeaderSubtitle,
  ProductHeaderTitle,
  ProductHeaderWrapper,
} from './styled-components'

type Props = {
  productKey: ProductKey
  showValueProps: boolean
}

const PRODUCTS_TO_ICONS = {
  [ProductKey.Invest]: AcornsIcon.Icon.ProductColorInvestFv,
  [ProductKey.Later]: AcornsIcon.Icon.ProductColorLaterFv,
  [ProductKey.Spend]: AcornsIcon.Icon.ProductColorSpendFv,
  [ProductKey.Early]: AcornsIcon.Icon.ProductColorEarlyFv,
  [ProductKey.PremiumEducation]: AcornsIcon.Icon.CategoryCollegeFv,
  [ProductKey.BenefitsWillStandard]: AcornsIcon.Icon.ProductColorProtectFv,
}

const PRODUCT_ORDER = [
  ProductKey.Invest,
  ProductKey.Later,
  ProductKey.Spend,
  ProductKey.PremiumEducation,
  ProductKey.Early,
  ProductKey.BenefitsWillStandard,
]

export function renderProducts(tierProducts: TierProduct[]) {
  if (!tierProducts.length) return

  return PRODUCT_ORDER.filter(productKey =>
    tierProducts.some(product => product.key === productKey),
  ).map(productKey => (
    <TierProductComponent key={productKey} productKey={productKey} showValueProps={true} />
  ))
}

const TierProductComponent = ({ productKey, showValueProps }: Props) => {
  const productIcon = PRODUCTS_TO_ICONS[productKey]
  // The lowerCase function is going to temporarily used here
  // When this was first implemented, the enum ProductKey value was not used as the object key
  // and instead hard-coded values. This is to prevent a huge refactor
  const productCopy = DYNAMIC_COPY.products[productKey.toLowerCase()]
  if (!productCopy) {
    return null
  }

  return (
    <div key={productKey}>
      <ProductHeaderWrapper hasValueProps={showValueProps}>
        {productIcon && <AcornsIcon icon={productIcon} width={24} height={24} />}
        <ProductHeaderCopy>
          <ProductHeaderTitle>{productCopy.title}</ProductHeaderTitle>
          <ProductHeaderSubtitle>{productCopy.subtitle}</ProductHeaderSubtitle>
        </ProductHeaderCopy>
      </ProductHeaderWrapper>
    </div>
  )
}
